import React, { PropTypes, Component } from 'react'
import styles from './styles'
import misc from 'utils/misc'
import PrintRow from './printRow'

export default class PrintTable extends Component {
  static propTypes = {
    thisMonday: PropTypes.object,
    records: PropTypes.array,
    projects: PropTypes.array,
    tasks: PropTypes.array,
  };

  constructor (props, context) {
    super(props, context)
  }

  render () {
    const { thisMonday, records, projects, tasks } = this.props

    const projectNames = misc.getDict(projects, 'name')
    const taskNames = misc.getDict(tasks, 'name')
    const wdName = ['一', '二', '三', '四', '五', '六', '日']
    const weekdayStrings = [];
    [1, 2, 3, 4, 5, 6, 0].forEach(wd => {
      weekdayStrings.push(misc.getDateString(thisMonday, wd))
    })
    const tableRows = []
    weekdayStrings.forEach((dateString, i) => {
      records.forEach(record => {
        if (record.dateString === dateString) {
          const { projectId, taskId, nTime, note, oSegments } = record
          tableRows.push(
            <PrintRow
              key={record._id}
              date={dateString}
              weekDay={wdName[i]}
              project={projectNames[projectId]}
              task={taskNames[taskId]}
              nTime={(nTime / 2.0).toFixed(1)}
              oTime={(misc.getOTime(record) / 2.0).toFixed(1)}
              oSegments={oSegments}
              note={note}
            />
          )
        }
      })
    })


    return (
      <table className={styles.printTable}>
        <tbody>
          <tr>
            <th>日期</th>
            <th>星期</th>
            <th>專案名稱</th>
            <th>內容代碼</th>
            <th>正常</th>
            <th>加班</th>
            <th>加班時段</th>
            <th>註解</th>
          </tr>
          {tableRows}
        </tbody>
      </table>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timesheet/printTable.jsx